export default {"src":"/_next/static/media/google.8285e3f5.svg","height":41,"width":40,"blurWidth":0,"blurHeight":0};